import { useTranslation } from 'react-i18next'
import { Dispatch, SetStateAction } from 'react'
import MobileButton from '../MobileButton/MobileButton'
import styles from './Drawer.module.scss'

interface DrawerProps {
  setIsTransparentDrawerOpen: Dispatch<SetStateAction<boolean>>
  isTransparentDrawerOpen: boolean
}

function Drawer({
  setIsTransparentDrawerOpen,
  isTransparentDrawerOpen
}: DrawerProps) {
  const { t } = useTranslation()
  return (
    <div className={styles.drawerWrapper}>
      <div className={styles.drawerContainer}>
        <MobileButton
          onClick={() => setIsTransparentDrawerOpen(!isTransparentDrawerOpen)}
          variant="contained"
          label={
            isTransparentDrawerOpen
              ? t('MOBILE_APP.VENUEPAGE.HEADER.CLOSE_BUTTON_LABEL')
              : t('MOBILE_APP.VENUEPAGE.HEADER.PAY_BUTTON_LABEL')
          }
        />
      </div>
    </div>
  )
}

export default Drawer
